import { motion } from "framer-motion";

const Impressum = () => {
    return (
        <section
            className="pt-32 md:pt-40 pb-20 md:pb-28"
            data-testid="impressum-page"
        >
            <div className="max-w-3xl mx-auto px-6 md:px-12">
                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-xs uppercase tracking-[0.28em] text-ls-inkSoft font-sans mb-6"
                >
                    <span className="inline-block w-8 h-px bg-ls-ink align-middle mr-3" />
                    Rechtliches
                </motion.p>
                <motion.h1
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    className="font-serif text-5xl md:text-7xl text-ls-ink tracking-tight mb-12"
                >
                    Impressum
                </motion.h1>

                <div className="space-y-10 font-sans text-ls-inkSoft leading-relaxed">
                    <Block
                        title="Angaben gemäß § 5 TMG"
                        body={
                            <>
                                LS Design & Consulting
                                <br />
                                Inhaber: L. Schmidt
                                <br />
                                Musterstraße 1<br />
                                10115 Berlin
                                <br />
                                Deutschland
                            </>
                        }
                    />
                    <Block
                        title="Kontakt"
                        body={
                            <>
                                Telefon: +49 (0) 30 12345678
                                <br />
                                E-Mail: info@ls-dc.de
                            </>
                        }
                    />
                    <Block
                        title="Umsatzsteuer-ID"
                        body={
                            <>
                                Umsatzsteuer-Identifikationsnummer gemäß § 27a
                                Umsatzsteuergesetz:
                                <br />
                                DE000000000
                            </>
                        }
                    />
                    <Block
                        title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV"
                        body={
                            <>
                                L. Schmidt
                                <br />
                                Musterstraße 1, 10115 Berlin
                            </>
                        }
                    />
                    <Block
                        title="Haftung für Inhalte"
                        body={
                            <>
                                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG
                                für eigene Inhalte auf diesen Seiten nach den
                                allgemeinen Gesetzen verantwortlich. Nach §§ 8
                                bis 10 TMG sind wir als Diensteanbieter jedoch
                                nicht verpflichtet, übermittelte oder
                                gespeicherte fremde Informationen zu überwachen
                                oder nach Umständen zu forschen, die auf eine
                                rechtswidrige Tätigkeit hinweisen.
                            </>
                        }
                    />
                    <Block
                        title="Urheberrecht"
                        body={
                            <>
                                Die durch die Seitenbetreiber erstellten Inhalte
                                und Werke auf diesen Seiten unterliegen dem
                                deutschen Urheberrecht. Beiträge Dritter sind
                                als solche gekennzeichnet. Die Vervielfältigung,
                                Bearbeitung, Verbreitung und jede Art der
                                Verwertung außerhalb der Grenzen des
                                Urheberrechtes bedürfen der schriftlichen
                                Zustimmung des jeweiligen Autors bzw. Erstellers.
                            </>
                        }
                    />
                    <p className="text-xs italic text-ls-inkSoft/70 pt-6 border-t border-ls-ink/10">
                        Hinweis: Die obigen Angaben sind Platzhalter. Bitte
                        passen Sie Adresse, Telefon, USt-ID und weitere Angaben
                        vor Live-Gang an Ihre tatsächlichen Daten an.
                    </p>
                </div>
            </div>
        </section>
    );
};

const Block = ({ title, body }) => (
    <div>
        <h2 className="font-serif text-2xl md:text-3xl text-ls-ink mb-3">
            {title}
        </h2>
        <p>{body}</p>
    </div>
);

export default Impressum;
